module.exports = __webpack_public_path__ + "img/bgw1.1b973117.jpg";